export const UPDATE_QUERY = 'UPDATE_QUERY';
export const RESET_QUERY = 'RESET_QUERY';

export const PUSH_PATH_NAME = 'PUSH_PATH_NAME';

export const SET_DEFAULT_MEDIATYPE = 'SET_DEFAULT_MEDIATYPE'
export const SET_DEFAULT_MEDIATYPE_SUCCESS = 'SET_DEFAULT_MEDIATYPE_SUCCESS'

export const updateQuery = (query) => ({
  type: UPDATE_QUERY,
  query,
});

export const resetQuery = (query) => ({
  type: RESET_QUERY,
  query,
});

export const setDefaultMediaType = (data) => ({
  type: SET_DEFAULT_MEDIATYPE,
  data
})

export const setDefaultMediaTypeSuccess = () => ({
  type: SET_DEFAULT_MEDIATYPE_SUCCESS,
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/router/actions.js
 **/